<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>
                  {{ $vuetify.lang.t('$vuetify.user.forgottenPassword') }}
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitResetPassword">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    name="email"
                    type="email"
                    outlined
                    prepend-icon="$vuetify.icons.user"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link class="text-decoration-none" :to="{ name: 'login' }">
                  <v-btn color="grey lighten-2">
                    Login
                  </v-btn>
                </router-link>
                <div class="flex-grow-1" />
                <v-btn color="primary" :disabled="!email" @click="sendEmail">
                  {{ $vuetify.lang.t('$vuetify.labels.send') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: null,
    };
  },

  methods: {
    submitResetPassword() {
      const { email, password } = this;
      this.attemptLogin({ email, password }).then(() => {
        this.$router.push({ name: 'orders' });
      });
    },
    async sendEmail() {
      await axios
        .post('passwords/user', { email: this.email })
        .then(() => {
          this.$store.dispatch(
            'alerts/OPEN_SUCCESS',
            this.$vuetify.lang.t('$vuetify.messages.sendPasswordResetSuccess')
          );
          this.$router.push({ name: 'login' });
        })
        .catch(error => {
          if (error.response.status === 429) {
            this.$store.dispatch('alerts/OPEN_ERROR', this.$vuetify.lang.t('$vuetify.messages.APICallsNumberExceeded'));
          } else if (error.response.data.errors) {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.errors[0].message);
          } else {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.message);
          }
        });
    },
  },
};
</script>
